import React from 'react';
import { DPDParcelMachine, SmartpostParcelMachine, OmnivaParcelMachine } from '../../types/shipping';

interface FormData {
  address?: {
    street: string;
    city: string;
    postalCode: string;
  };
}

interface CheckoutAddressFormProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  shippingMethod: string;
  dpdParcelMachines: DPDParcelMachine[];
  smartpostParcelMachines: SmartpostParcelMachine[];
  omnivaParcelMachines: OmnivaParcelMachine[];
  parcelMachineSearch: string;
  setParcelMachineSearch: (search: string) => void;
}

export function CheckoutAddressForm({
  formData,
  setFormData,
  shippingMethod,
  dpdParcelMachines,
  smartpostParcelMachines,
  omnivaParcelMachines,
  parcelMachineSearch,
  setParcelMachineSearch
}: CheckoutAddressFormProps) {
  if (shippingMethod === 'Tulen ise järgi') {
    return null;
  }

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Sisesta transpordi aadress</h2>
      {shippingMethod === 'DPD Pakiautomaat' ? (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Otsi pakiautomaati
          </label>
          <input
            type="text"
            placeholder="Sisesta aadress või linn..."
            value={parcelMachineSearch}
            onChange={(e) => setParcelMachineSearch(e.target.value)}
            className="w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent"
          />
          <div
            className="mt-4 border rounded-lg"
            style={{
              maxHeight: '300px',
              overflowY: 'scroll',
              WebkitOverflowScrolling: 'touch',
              overscrollBehavior: 'contain'
            }}
            onWheel={(e) => e.stopPropagation()}
          >
            {dpdParcelMachines
              .filter(machine => {
                const searchLower = parcelMachineSearch.toLowerCase();
                return (
                  machine.name.toLowerCase().includes(searchLower) ||
                  machine.address.street.toLowerCase().includes(searchLower) ||
                  machine.address.city.toLowerCase().includes(searchLower)
                );
              })
              .map(machine => (
                <button
                  key={machine.id}
                  className={`w-full text-left px-4 py-3 transition-colors duration-200 ${
                    formData.address?.street === `${machine.name} - ${machine.address.street}`
                      ? 'bg-[#4FC1E9]/10 hover:bg-[#4FC1E9]/20'
                      : 'hover:bg-gray-50'
                  }`}
                  onClick={() => {
                    setFormData(prev => ({
                      ...prev,
                      address: {
                        street: `${machine.name} - ${machine.address.street}`,
                        city: machine.address.city,
                        postalCode: machine.address.postalCode
                      }
                    }));
                  }}
                >
                  <div className={`font-medium ${
                    formData.address?.street === `${machine.name} - ${machine.address.street}`
                      ? 'text-[#4FC1E9]'
                      : ''
                  }`}>{machine.name}</div>
                  <div className="text-sm text-gray-500">
                    {machine.address.street}, {machine.address.city}
                  </div>
                </button>
              ))}
          </div>
        </div>
      ) : shippingMethod === 'Smartposti Pakiautomaat' ? (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Otsi pakiautomaati
          </label>
          <input
            type="text"
            placeholder="Sisesta aadress või linn..."
            value={parcelMachineSearch}
            onChange={(e) => setParcelMachineSearch(e.target.value)}
            className="w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent"
          />
          <div
            className="mt-4 border rounded-lg"
            style={{
              maxHeight: '300px',
              overflowY: 'scroll',
              WebkitOverflowScrolling: 'touch',
              overscrollBehavior: 'contain'
            }}
            onWheel={(e) => e.stopPropagation()}
          >
            {smartpostParcelMachines
              .filter(machine => {
                const searchLower = parcelMachineSearch.toLowerCase();
                return (
                  machine.name.toLowerCase().includes(searchLower) ||
                  machine.address.toLowerCase().includes(searchLower) ||
                  machine.city.toLowerCase().includes(searchLower)
                );
              })
              .map(machine => (
                <button
                  key={machine.id}
                  className={`w-full text-left px-4 py-3 transition-colors duration-200 ${
                    formData.address?.street === `${machine.name} - ${machine.address}`
                      ? 'bg-[#4FC1E9]/10 hover:bg-[#4FC1E9]/20'
                      : 'hover:bg-gray-50'
                  }`}
                  onClick={() => {
                    setFormData(prev => ({
                      ...prev,
                      address: {
                        street: `${machine.name} - ${machine.address}`,
                        city: machine.city,
                        postalCode: machine.postalcode
                      }
                    }));
                  }}
                >
                  <div className={`font-medium ${
                    formData.address?.street === `${machine.name} - ${machine.address}`
                      ? 'text-[#4FC1E9]'
                      : ''
                  }`}>{machine.name}</div>
                  <div className="text-sm text-gray-500">
                    {machine.address}, {machine.city}
                  </div>
                </button>
              ))}
          </div>
        </div>
      ) : shippingMethod === 'Omniva Pakiautomaat' ? (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Otsi pakiautomaati
          </label>
          <input
            type="text"
            placeholder="Sisesta aadress või linn..."
            value={parcelMachineSearch}
            onChange={(e) => setParcelMachineSearch(e.target.value)}
            className="w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent"
          />
          <div
            className="mt-4 border rounded-lg"
            style={{
              maxHeight: '300px',
              overflowY: 'scroll',
              WebkitOverflowScrolling: 'touch',
              overscrollBehavior: 'contain'
            }}
            onWheel={(e) => e.stopPropagation()}
          >
            {omnivaParcelMachines
              .filter(machine => {
                const searchLower = parcelMachineSearch.toLowerCase();
                return (
                  machine.name.toLowerCase().includes(searchLower) ||
                  machine.address.toLowerCase().includes(searchLower) ||
                  machine.town.toLowerCase().includes(searchLower) ||
                  machine.county.toLowerCase().includes(searchLower)
                );
              })
              .map((machine, index) => (
                <button
                  key={`${machine.name}-${index}`}
                  className={`w-full text-left px-4 py-3 transition-colors duration-200 ${
                    formData.address?.street === `${machine.name} - ${machine.address}`
                      ? 'bg-[#4FC1E9]/10 hover:bg-[#4FC1E9]/20'
                      : 'hover:bg-gray-50'
                  }`}
                  onClick={() => {
                    setFormData(prev => ({
                      ...prev,
                      address: {
                        street: `${machine.name} - ${machine.address}`,
                        city: machine.town,
                        postalCode: machine.zip
                      }
                    }));
                  }}
                >
                  <div className={`font-medium ${
                    formData.address?.street === `${machine.name} - ${machine.address}`
                      ? 'text-[#4FC1E9]'
                      : ''
                  }`}>{machine.name}</div>
                  <div className="text-sm text-gray-500">
                    {machine.address}, {machine.town}
                    {machine.county && `, ${machine.county}`}
                  </div>
                </button>
              ))}
          </div>
        </div>
      ) : (
        <>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Tänav</label>
            <input
              type="text"
              name="street"
              className="w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent"
            />
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Linn</label>
              <input
                type="text"
                name="city"
                className="w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Postiindeks</label>
              <input
                type="text"
                name="postalCode"
                className="w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent"
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}